import React, { Component, PropsWithChildren } from 'react';
import './navigate.scss';

export interface IProps extends PropsWithChildren<{}> {
    to: string;
    onClick?(): void;
}

export default class NavigateItem extends Component<IProps, {}> {
    constructor(props: IProps) {
        super(props);
    }

    public clickHandle = () => {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };

    public render() {
        return (
            <span onClick={this.clickHandle} className="navigate-item">
                {this.props.children}
            </span>
        );
    }
}
